import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {
  BannerBoldText,
  BannerFlexWrapper,
  BannerTextWrapper,
} from '../../../Banner';
import * as S from './AddVersionHelpBanner.styles';
import {AddVersionHelpBannerNoLoggedVersions} from './AddVersionHelpBannerNoLoggedVersions';

type AddVersionHelpBannerProps = {
  hasLoggedVersions?: boolean;
  artifactTypeName: string;
  hideSkipBanner?: boolean;
};

export const AddVersionHelpBanner = ({
  hasLoggedVersions,
  artifactTypeName,
  hideSkipBanner,
}: AddVersionHelpBannerProps) => {
  if (hasLoggedVersions) {
    if (!hideSkipBanner) {
      return (
        <S.BannerWithMargin variant="info">
          <BannerFlexWrapper>
            <Icon name="info" style={{marginBottom: 'auto'}} />
            <BannerTextWrapper>
              <BannerBoldText>
                Collections can have multiple linked {artifactTypeName}s. Link
                your best version now or you can do this step later.
              </BannerBoldText>
            </BannerTextWrapper>
          </BannerFlexWrapper>
        </S.BannerWithMargin>
      );
    }
    return null;
  }
  return (
    <AddVersionHelpBannerNoLoggedVersions artifactTypeName={artifactTypeName} />
  );
};
